import React from 'react'
import shape from '../../../images/shape/about-glassisom.png'

const About = (props) => {

    return (
        <section className="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="da-about-left">
                            <h2 className="title">Well-harnessed data <br /> is the catalyst to <br /> business success.</h2>
                            <div className="img"><img src={shape} alt="" /></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="da-about-right">
                            <p className="content">*Jyasa* — workplace for creatives — in the Newari tongue of the Kathmandu Valley. We are a boutique software house operating at the intersection of deep craft and modern technology.</p>
                            <p className="content">Our model is simple: a lean, experienced leadership team paired with a world-class offshore development house in Kathmandu.</p>
                            <p className="content">We work with clients who value thoughtful engineering — not just shipping fast, but shipping right. From regulated industries like healthcare to ambitious product startups, we bring the same rigour to every engagement.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;